import { combineReducers } from "redux";
import page from "./reducers/page";
import routes from "./reducers/routes";
import footer from "./reducers/footer";
import meta from "./reducers/meta";
import modal from "./reducers/modal";
import navigation from "./reducers/navigation";
import csrf from "./reducers/csrf";
import cta from "./reducers/cta";
import standards from "./reducers/standards"
import loaded from "./reducers/loaded"

export default combineReducers({
    page,
    meta,
    navigation,
    routes,
    modal,
    csrf,
    cta,
    standards,
    footer,
    loaded
});



// WEBPACK FOOTER //
// ./src/rootReducer.js